export const platformReviews = [
  {
    platform: "RightFirms",
    rating: "3.9",
    count: "120 Reviews",
    starColor: "#1A5EFC",
    accentColor: "#1A5EFC",
    bg: "#1A5EFC",
    icon: "/images/credentials/RightFirms-Icon.webp",
    href: "https://www.rightfirms.co/company/velanapps",
    abbr: "R",
  },
  {
    platform: "Fixnhour",
    starColor: "#E8533B",
    accentColor: "#E8533B",
    bg: "#E8533B",
    icon: "/images/credentials/Fixnhour-Icon.webp",
    href: "https://fixnhour.com/company/profile/velanapps",
    abbr: "F",
  },
  {
    platform: "Clutch",
    starColor: "#EE3D2C",
    accentColor: "#EE3D2C",
    bg: "#EE3D2C",
    abbr: "C",
    icon: "/images/credentials/Clutch-Icon.webp",
    href: "https://clutch.co/profile/velanapps",
  },
  {
    platform: "Trustpilot",
    starColor: "#00B67A",
    accentColor: "#00B67A",
    bg: "#00B67A",
    abbr: "T",
    icon: "/images/credentials/Trustpilot-Icon.webp",
    href: "https://www.trustpilot.com/review/velanapps.com",
  },
  {
    platform: "Google",
    starColor: "#4285F4",
    accentColor: "#4285F4",
    bg: "#4285F4",
    abbr: "G",
    icon: "/images/credentials/Google-Icon.webp",
    href: "https://www.google.com/search?q=velanapps",
  },
  {
    platform: "Tech Behemoths",
    starColor: "#3672ff",
    accentColor: "#3672ff",
    bg: "#3672ff",
    abbr: "Y",
    icon: "/images/credentials/Tech-Behemoths-Icon.webp",
    href: "https://techbehemoths.com/company/velanapps",
  },
  {
    platform: "TechReviewer",
    starColor: "#1E88E5",
    accentColor: "#1E88E5",
    bg: "#1E88E5",
    abbr: "TR",
    icon: "/images/credentials/Techreviewer-Icon.webp",
    href: "https://techreviewer.co/companies/velanapps",
  },
  {
    platform: "GoodFirms",
    starColor: "#FF6250",
    accentColor: "#FF6250",
    bg: "#FF6250",
    abbr: "GF",
    icon: "/images/credentials/Goodfirms-Icon.webp",
    href: "https://www.goodfirms.co/company/velanapps",
  },
  {
    platform: "ITProfiles",
    starColor: "#E8533B",
    accentColor: "#E8533B",
    bg: "#E8533B",
    abbr: "IP",
    icon: "/images/credentials/IT-Profiles-Icon.webp",
    href: "https://itprofiles.com/company/velanapps",
  },
];
